import { render, staticRenderFns } from "./ReadOnlyMetaData.vue?vue&type=template&id=6fcb095a&"
import script from "./ReadOnlyMetaData.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fcb095a')) {
      api.createRecord('6fcb095a', component.options)
    } else {
      api.reload('6fcb095a', component.options)
    }
    module.hot.accept("./ReadOnlyMetaData.vue?vue&type=template&id=6fcb095a&", function () {
      api.rerender('6fcb095a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/ReadOnlyMetaData.vue"
export default component.exports